import Navbar from "../../components/main/Navbar";
import SearchHeader from "../../components/main/SearchHeader";
import Loading from "../../components/atoms/Loading";
import Table2 from "../../components/main/Table/Table2";
import {HeaderAdminList} from "../../data/TablesHeader";
import ListsOperations from "../../tools/consts";
import Pagination from "../../components/main/Pagination";
import ModalAdmin from "../../components/adminPage/ModalAdmin";
import NewModal from "../../components/atoms/new/NewModal";
import AdminModalContent from "../../components/adminPage/AdminModalContent";
import DeleteModal from "../../components/atoms/DeleteModal";
import React from "react";
import useAdminContext from "./AdminsContext";
import TableSearchHeader from "../../components/CustomTable/TableSearchHeader";
import ListPaginationWithLimit from "../../components/pagination/ListPaginationWithLimit";
import AddAdminModal from "./AddAdminModal";

const AdminsScreen = () => {

    const {
        onSearchBtnClick,
        changePage,
        onDevicePerPageChange,
        onAcceptDeleteAdminClick,
        listState,
        closeModal,
        modalState,
        openDeleteModal,
        openAddEditModal,
    } = useAdminContext();

    return (
        <div className="pb-7.5px">
            {/* Navbar Component */}
            <Navbar titles={["کاربر‌ها", "فهرست مدیران"]}/>
            <div
                className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px"
                dir="rtl">
                <TableSearchHeader
                    title={"فهرست مدیران"}
                    number={listState.countAll}
                    placeholder={"جست و جو: شماره تماس، نام"}
                    onSearchBtnClick={onSearchBtnClick}

                    buttnText={"افزودن مدیر جدید"}
                    hasBtn={true}
                    exportFile={false}
                    path={""}
                    onClick={() => {
                        openAddEditModal()
                    }}
                />
                {listState.loading ? (
                    <Loading height={"h-66"}/>
                ) : (
                    <>
                        <Table2
                            tableData={listState.list}
                            headers={HeaderAdminList}
                            pageNumber={listState.pageNumber}
                            limit={listState.pageLimit}
                            hasOperation={true}

                            emptyText={"تاریخچه‌ای یافت نشد"}
                            heightEmptyState={"h-492"}
                            operations={ListsOperations.getAdminsList(openDeleteModal, openAddEditModal)}
                        />
                        <ListPaginationWithLimit
                            changePage={changePage}
                            countAll={listState.countAll}
                            currentPage={listState.pageNumber}
                            devicePerPageLimit={listState.pageLimit}
                            onDevicePerPageChange={onDevicePerPageChange}
                        />
                    </>
                )}
                <AddAdminModal/>

                <DeleteModal
                    text={`آیا برای حذف “${modalState.selectedItem == null ? "" : modalState.selectedItem.name}” مطمئن هستید؟`}
                    showDeleteModal={modalState.mode === "delete" && modalState.isOpen}
                    closeDeleteModal={closeModal}
                    RemoveItem={onAcceptDeleteAdminClick}
                    title="اخطار حذف اطلاعات"
                />
            </div>
        </div>
    );

}
export default AdminsScreen